import getTableToItemRelationKey from './getTableToItemRelationKey';
import type TableViewItemRelation from '../store/schema/TableViewItemRelation';
import { getListViewStore } from '../store/Store';

/**
 * Get the TableView-Item relation based on the itemId and tableView id
 */
export default function getTableItemRelation(
    itemId: string,
    tableViewId: string
): TableViewItemRelation {
    const relationKey = getTableToItemRelationKey(itemId, tableViewId);
    return getListViewStore().tableViewItemRelations.get(relationKey);
}
